import ContentLoader from "react-content-loader";
import React from "react";

export const ProductLoader = i => (
    <ContentLoader
        height={399}
        width={350}
        speed={2}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
        style={i > 2 ? {marginTop: 20} : {}}
    >
        {/*Picture*/}
        <rect x="115" y="15" rx="4" ry="4" width="120" height="200"/>

        {/*Name*/}
        <rect x="0" y="225" rx="3" ry="3" width="350" height="12"/>
        <rect x="50" y="245" rx="3" ry="3" width="250" height="12"/>

        {/*Price*/}
        <rect x="155" y="265" rx="3" ry="3" width="40" height="12"/>

        {/*Details*/}
        <rect x="155" y="285" rx="3" ry="3" width="40" height="12"/>

        {/*Button*/}
        <rect x="0" y="345" rx="3" ry="3" width="100" height="40"/>
        <rect x="115" y="345" rx="3" ry="3" width="235" height="40"/>
    </ContentLoader>
);

export const ProductDetailLoader = () => (
    <ContentLoader
        height={800}
        width={800}
        speed={2}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        {/*Picture*/}
        <rect x="15" y="15" rx="4" ry="4" width="255" height="420"/>

        {/*Title*/}
        <rect x="285" y="15" rx="3" ry="3" width="700" height="30"/>
        <rect x="285" y="55" rx="3" ry="3" width="150" height="30"/>

        {/*Price*/}
        <rect x="285" y="95" rx="3" ry="3" width="40" height="14"/>

        {/*Description*/}
        <rect x="285" y="125" rx="3" ry="3" width="800" height="12"/>
        <rect x="285" y="145" rx="3" ry="3" width="800" height="12"/>
        <rect x="285" y="165" rx="3" ry="3" width="800" height="12"/>
        <rect x="285" y="185" rx="3" ry="3" width="800" height="12"/>
        <rect x="285" y="205" rx="3" ry="3" width="800" height="12"/>
        <rect x="285" y="225" rx="3" ry="3" width="800" height="12"/>
        <rect x="285" y="245" rx="3" ry="3" width="800" height="12"/>
        <rect x="285" y="265" rx="3" ry="3" width="800" height="12"/>

        {/*Button*/}
        <rect x="285" y="325" rx="3" ry="3" width="100" height="40"/>
        <rect x="400" y="325" rx="3" ry="3" width="235" height="40"/>
    </ContentLoader>
);

export const SpecLoader = () => (
    <ContentLoader
        height={399}
        width={1200}
        speed={2}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="0" y="0" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="0" rx="3" ry="3" width="460" height="12"/>
        <rect x="740" y="0" rx="3" ry="3" width="370" height="12"/>

        <rect x="0" y="30" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="30" rx="3" ry="3" width="300" height="12"/>
        <rect x="740" y="30" rx="3" ry="3" width="250" height="12"/>

        <rect x="0" y="60" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="60" rx="3" ry="3" width="320" height="12"/>
        <rect x="740" y="60" rx="3" ry="3" width="170" height="12"/>

        <rect x="0" y="90" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="90" rx="3" ry="3" width="400" height="12"/>
        <rect x="740" y="90" rx="3" ry="3" width="360" height="12"/>

        <rect x="0" y="120" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="120" rx="3" ry="3" width="250" height="12"/>
        <rect x="740" y="120" rx="3" ry="3" width="180" height="12"/>

        <rect x="0" y="150" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="150" rx="3" ry="3" width="310" height="12"/>
        <rect x="740" y="150" rx="3" ry="3" width="340" height="12"/>

        <rect x="0" y="180" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="180" rx="3" ry="3" width="280" height="12"/>
        <rect x="740" y="180" rx="3" ry="3" width="290" height="12"/>

        <rect x="0" y="210" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="210" rx="3" ry="3" width="420" height="12"/>
        <rect x="740" y="210" rx="3" ry="3" width="320" height="12"/>

        <rect x="0" y="240" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="240" rx="3" ry="3" width="150" height="12"/>
        <rect x="740" y="240" rx="3" ry="3" width="200" height="12"/>

        <rect x="0" y="270" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="270" rx="3" ry="3" width="300" height="12"/>
        <rect x="740" y="270" rx="3" ry="3" width="210" height="12"/>

        <rect x="0" y="300" rx="3" ry="3" width="180" height="12"/>
        <rect x="220" y="300" rx="3" ry="3" width="170" height="12"/>
        <rect x="740" y="300" rx="3" ry="3" width="240" height="12"/>
    </ContentLoader>
);